var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[_c('panelify',{attrs:{"extName":"Panelify-demo","appName":"AEFT","src":"https://zealous-franklin-1d29ab.netlify.com/#/","width":"340px","height":"400px","gradient":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }